import * as React from "react"

import PropTypes from "prop-types"

import logo from "../../img/logo.jpg"
import ButtonPrimary from "../ButtonPrimary/buttonPrimary"
import {texts} from "./texts"

import "./errorBoundary.scss"

const ErrorBoundary = ({redirectToHomePage}) => (
    <div className="error-component">
        <div className="outer">
            <div className="inner">
                <div className="content">
                    <img alt="" aria-hidden="true" className="logo" src={logo} />
                    <h1>{texts.oups}</h1>
                    <p>{texts.erreurTechnique}</p>
                    <ButtonPrimary onClick={redirectToHomePage}>{texts.boutonLienAccueil}</ButtonPrimary>
                </div>
            </div>
        </div>
    </div>
)

ErrorBoundary.propTypes = {
    redirectToHomePage: PropTypes.func.isRequired,
}

export default ErrorBoundary
